import { defineComponent, h } from 'vue';
import BaseFieldsetComponent from './baseFieldsetMixin.jsx';
import utils from '../../../Shared/utils.jsx';

export default defineComponent({
    name: 'sform-actions',
    mixins: [BaseFieldsetComponent],
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    methods: {
    },
    render() {
        if (!this.form)
            return null;

        const rows = this.generateElements(h, this.form, this.layouttype);

        return (
            <QCard flat bordered class="mb-1 pa-1">
                {rows}
            </QCard>
        );
    }
});